<div nz-row>
    <div nz-col nzSpan="6">
        <span class="pageTitle">Approver Mappings</span>
    </div>
    <div nz-col nzSpan="8" >
        <div class="search-container" *ngIf="currentUser.Is_Partner">  
            <nz-input-group [nzPrefix]="searchIcon">
                <input
                    nz-input
                    type="text"
                    placeholder="Enter minimum 3 characters to search..."
                    [(ngModel)]="searchText"                    
                    class="search-box"
                />
            </nz-input-group>
            <ng-template #searchIcon>
                <i nz-icon nzType="search" style="color: #0b2d71;"></i>
            </ng-template>   
        </div>
    </div>
    <div nz-col nzSpan="10">
        <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
            <button nz-button nzType="primary" (click)="showCreateModal()" [nzLoading]="isConfirmLoadingForCreateButton" >
                <i nz-icon nzType="file-add" nzTheme="outline"  style="color: white;"></i> Add Approvers
            </button>
        </div>
    </div>
</div> 



<nz-table #deptApproverDetailsTable [nzData]="deptApproverDetails" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true" >
    <thead>
        <tr>        
            <th *ngFor="let column of listOfColumn"    
                [nzShowSort]="column.allowSorting"
                [nzSortFn]="column.compare" 
                [nzSortPriority]="column.priority" style="padding: 5px;">
                {{ column.title }}
            </th>           
        </tr>        
    </thead>
    <tbody>
        <tr *ngFor="let data of deptApproverDetailsTable.data">
            <td>{{ data.Department_Name}} </td>
            <td>{{ data.Department_Status? 'Active' : 'Inactive'}} </td>
            <td>{{ data.Sub_Dept_Name }}</td>
            <td [innerHTML]="data.DeptRepName"></td>
            <td>{{ data.JVAdvisorName }}</td>
            <td>{{ data.DeptViewerName }}</td>
            <td>{{ data.Sub_Dept_Status }}</td>
            <td>
                <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;"> 
                    <button nz-button nzType="primary" [nzSize]="'small'" style="margin-right: 5px;" (click)="showEditModal(data)">
                        <i nz-icon nzType="edit" nzTheme="outline"  style="color: white;"></i> Edit
                    </button> 
                     
                </div>
            </td>
        </tr>
    </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isVisible" nzTitle="{{ isEditMode ? 'Edit Approver' : 'Add Approver' }}" (nzOnCancel)="handleCancel()" [nzClosable]="false">
    <div *nzModalContent>
      <form [formGroup]="approverForm">
        <div class="row form-group">
          <div class="col-md-4">
            <label class="required">Department<span class="text-danger">*</span></label>
          </div>
          <div class="col-md-8">
            <nz-select formControlName="department" nzPlaceHolder="Select Department" style="width: 100%;">
              <nz-option *ngFor="let dept of departmentMaster" [nzValue]="dept.Department_Code" [nzLabel]="dept.Department_Name"></nz-option>
            </nz-select>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-4">
            <label class="required">Sub-Department<span class="text-danger">*</span></label>
          </div>
          <div class="col-md-8">
            <nz-select formControlName="subDepartment" nzPlaceHolder="Select Sub-Department" style="width: 100%;">
              <nz-option *ngFor="let subDept of subDeptMaster" [nzValue]="subDept.Sub_Dept_Code" [nzLabel]="subDept.Sub_Dept_Name"></nz-option>
            </nz-select>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-4">
            <label class="required">Dept Representative<span class="text-danger">*</span></label>
          </div>
          <div class="col-md-8">
            <nz-select formControlName="deptRepresentative" nzMode="multiple" nzPlaceHolder="Select Representatives" style="width: 100%;">
              <nz-option *ngFor="let rep of deptRepresentvMaster" [nzValue]="rep.User_Code" [nzLabel]="rep.User_Name"></nz-option>
            </nz-select>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-4">
            <label class="required">JV Advisor<span class="text-danger">*</span></label>
          </div>
          <div class="col-md-8">
            <nz-select formControlName="jvAdvisor" nzPlaceHolder="Select JV Advisor" style="width: 100%;">
              <nz-option *ngFor="let jv of JVUserMaster" [nzValue]="jv.User_Code" [nzLabel]="jv.User_Name"></nz-option>
            </nz-select>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-4">
            <label class="required">Dept Viewer<span class="text-danger">*</span></label>
          </div>
          <div class="col-md-8">
            <nz-select formControlName="deptViewer" nzMode="multiple" nzPlaceHolder="Select Dept Viewer" style="width: 100%;">
              <nz-option *ngFor="let viewer of deptRepresentvMaster" [nzValue]="viewer.User_Code" [nzLabel]="viewer.User_Name"></nz-option>
            </nz-select>
          </div>
        </div>
      </form>
    </div>
    <div *nzModalFooter>
      <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
      <button nz-button nzType="primary" [disabled]="approverForm.invalid" (click)="handleOk()">
        {{ isEditMode ? 'Update' : 'Create' }}
      </button>
    </div>
  </nz-modal>

